import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash'
import { FormattedMessage, useIntl } from 'react-intl';
import 'draft-js/dist/Draft.css';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';
import Tooltip from '@mui/material/Tooltip';

import { nameFields, languageFieldMap, getSelectedOptionFieldsName } from '../../../i18n';

import GoogleFieldsAllTabs from './GoogleFieldsAllTabs';
import GoogleFieldsAllMetric from './GoogleFieldsAllMetric';
import GoogleFieldsSelected from './GoogleFieldsSelected';

import useGlobalStatus from '../../../hook/useGlobalStatus';

import { PagesOutlinedIcon, HelpOutlineIcon } from '../../../constants/images';

import { CustomFormLabel, BoxBorderGrey } from '../../customComponent';

import theme from '../../../theme';

import { allExcelSheets, generalData, conversionsData, tickConversionsData, tickAllConversionsData } from '../../../utils/GoogleFieldsDefined';


const mediaMainColor = theme.palette.google.main
const fieldsBlockHeight = '560px';
const fieldsBlockHeightS = '460px';


const GoogleFieldsData = (props) => {
  const {
    excelSheetSelected,
    handleModalDetail,
    inputErrorMsg,
    downloadInputErrorMsg,
    reportLanguage,
    currentSheetName,
    setCurrentSheetName,
    currentSheetOrigiName,
    setCurrentSheetOrigiName,
    selectedExcelIndex,
    setSelectedExcelIndex,
    setExcelSheetSelected,
    setAllExcelSheetChecked,
    allDisplayFields,
    setAllDisplayFields,
    updateSortFields,
    setUpdateSortFields,
    currentSheetSelectFields,
    setCurrentSheetSelectFields,
    currenOptionFields,
    setCurrenOptionFields,
    selectedGeneralFields,
    setSelectedGeneralFields,
    selectedConversionsFields,
    setSelectedConversionsFields,
    selectedCustomFields,
    setSelectedCustomFields,
    setOrigiCustomData,
    handleGetCustomFields,
    allExcelSheetChecked,
    selectedAdAccounts,
  } = props;

  const intl = useIntl();
  const { currentActiveData, setCurrentActiveData, entryPath } = useGlobalStatus();
  const [filterOptionFields, setFilterOptionFields] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");

  const getFieldsLanguage = (saveFields, saveLanguage, category) => {
    const nameKey = languageFieldMap[reportLanguage];

    const selectedFields = saveFields.map((edition) => {
      return {
        ...edition,
        [nameKey]: edition.name
      }
    })

    const isConversion = (field) => conversionsData.some(c => c.expression === field.expression);
    const isGeneral = (field) => generalData.some(g => g.expression === field.expression);

    return category === 'general'
      ? selectedFields.filter(field => !isConversion(field))
      : selectedFields.filter(field => !isGeneral(field));
  }

  const getEditReportFields = (saveFields, originalData, saveExcelSheets) => {
    return saveFields.map(field => {
      const origiFieldIndex = originalData.findIndex(el => el.expression === field.expression);

      if (origiFieldIndex > -1) {
        const origiSheet = originalData[origiFieldIndex].sheet;
        const excludeSavedSheet = _.difference(origiSheet, saveExcelSheets);
        return {
          ...field,
          sheet: Array.from(new Set([...field.sheet, ...excludeSavedSheet]))
        }
      }
      return field;
    }).sort((a, b) => a.indexNumber - b.indexNumber);
  }

  //取得儲存的欄位
  useEffect(() => {
    if (entryPath.includes('edit')) {
      const { fields, language, excelSheets, conversionsType } = currentActiveData;
      const newMergedFields = _.unionBy(fields, generalData, 'expression'); //將新增的欄位合併至已儲存的欄位
      const saveGeneralFields = getFieldsLanguage(newMergedFields, language, 'general').filter(el => !el.cid);
      const saveConversionsFields = getFieldsLanguage(newMergedFields, language, 'conversion').filter(el => !el.cid && el.type !== "CUSTOM" && el.type !== "FORMAT");

      const origiConversionsData =
        conversionsType === 'allConversions' ? tickAllConversionsData :
          conversionsType === 'conversions' ? tickConversionsData :
            conversionsData;

      setSelectedGeneralFields(getEditReportFields(saveGeneralFields, generalData, excelSheets));
      setSelectedConversionsFields(getEditReportFields(saveConversionsFields, origiConversionsData, excelSheets));
      setExcelSheetSelected(excelSheets);
    }
  }, [entryPath, currentActiveData])

  //預設選擇欄位
  useEffect(() => {
    if (entryPath.includes('create')) {
      setSelectedGeneralFields(generalData);
    }
  }, [entryPath])

  useEffect(() => {
    const nameKey = languageFieldMap[reportLanguage];

    const updateFieldsLanguage = (fields) => {
      return fields.map((field) => {
        const hasNameKey = Object.hasOwn(field, nameKey);

        return {
          ...field,
          [nameKey]: hasNameKey ? field[nameKey] : getSelectedOptionFieldsName('google', field, reportLanguage),
        };
      })
    }

    setSelectedGeneralFields((prev) => updateFieldsLanguage(prev));
    setSelectedConversionsFields((prev) => updateFieldsLanguage(prev));
    setSelectedCustomFields((prev) => updateFieldsLanguage(prev));
  }, [reportLanguage])

  useEffect(() => {
    if (excelSheetSelected.length === allExcelSheets.length) {
      setAllExcelSheetChecked(true);
    } else {
      setAllExcelSheetChecked(false);
    }
  }, [excelSheetSelected])

  useEffect(() => {
    let fields;

    if (searchKeyword) {
      fields = allDisplayFields.map(el => {
        const filterChild = el.child.filter(elem => {
          const lowerKeyword = searchKeyword.toLowerCase();
          return nameFields.some(
            key => elem[key] && elem[key].toLowerCase().includes(lowerKeyword)
          );
        })
        return { ...el, child: filterChild };
      });
    } else {
      fields = allDisplayFields;
    }

    setFilterOptionFields(fields);
  }, [searchKeyword, allDisplayFields])

  //改變選擇欄位
  const changeDefinedFields = (e, field) => {
    const { checked } = e.target;
    const generalData = JSON.parse(JSON.stringify(selectedGeneralFields));
    const conversionsData = JSON.parse(JSON.stringify(selectedConversionsFields));
    const customData = JSON.parse(JSON.stringify(selectedCustomFields));
    const generalIndex = _.findIndex(generalData, (el) => el.expression === field.expression);
    const conversionsIndex = _.findIndex(conversionsData, (el) => el.expression === field.expression);
    const customFieldsIndex = _.findIndex(customData, (el) => el.expression === field.expression);

    if (checked) {
      if (generalIndex > -1) {
        generalData[generalIndex].sheet.push(currentSheetOrigiName);
        setSelectedGeneralFields(generalData);

      } else if (conversionsIndex > -1) {
        conversionsData[conversionsIndex].sheet.push(currentSheetOrigiName);
        setSelectedConversionsFields(conversionsData);

      } else if (customFieldsIndex > -1) {
        customData[customFieldsIndex].sheet.push(currentSheetOrigiName);
        setSelectedCustomFields(customData);
      }

      setCurrentSheetSelectFields(prev => {
        const updatedFields = [...prev, { ...field, sheet: field.sheet.concat(currentSheetOrigiName) }]
        return updatedFields.sort((a, b) => {
          if (a.sort === null) return 1;
          if (b.sort === null) return -1;
          return a.sort - b.sort;
        });
      })

    } else {

      if (generalIndex > -1) {
        _.pull(generalData[generalIndex].sheet, currentSheetOrigiName);
        setSelectedGeneralFields(generalData);

      } else if (conversionsIndex > -1) {
        _.pull(conversionsData[conversionsIndex].sheet, currentSheetOrigiName);
        setSelectedConversionsFields(conversionsData);

      } else if (customFieldsIndex > -1) {
        _.pull(customData[customFieldsIndex].sheet, currentSheetOrigiName);
        setSelectedCustomFields(customData);
      }

      const deletFields = currentSheetSelectFields.filter((el) => {
        return el.expression !== field.expression;
      });

      setCurrentSheetSelectFields(deletFields);
    }
  }

  //刪除欄位
  const handleDeleteFields = (e, field, type) => {
    setCurrenOptionFields(null);

    let generalData = JSON.parse(JSON.stringify(selectedGeneralFields));
    let conversionsData = JSON.parse(JSON.stringify(selectedConversionsFields));
    let customData = JSON.parse(JSON.stringify(selectedCustomFields));
    let displayData = JSON.parse(JSON.stringify(allDisplayFields));

    const generalIndex = _.findIndex(generalData, (el) => el.expression === field.expression);
    const conversionsIndex = _.findIndex(conversionsData, (el) => el.expression === field.expression);
    const customFieldsIndex = _.findIndex(customData, (el) => el.expression === field.expression);

    if (field.expression === 'metrics.impressions' || field.expression === 'metrics.cost_micros') return;

    if (generalIndex > -1) {
      _.pull(generalData[generalIndex].sheet, currentSheetOrigiName)
      if (type === 'deleteField') {
        generalData = generalData.filter(el => !(el.expression === field.expression && (el.type === 'CUSTOM' || el.type === 'FORMAT') && !el.cid));
      }
      setSelectedGeneralFields(generalData);

    } else if (conversionsIndex > -1) {
      _.pull(conversionsData[conversionsIndex].sheet, currentSheetOrigiName);
      setSelectedConversionsFields(conversionsData);

    } else if (customFieldsIndex > -1) {
      _.pull(customData[customFieldsIndex].sheet, currentSheetOrigiName)
      setSelectedCustomFields(customData);
    }

    const deletFields = currentSheetSelectFields.filter(el => el.expression !== field.expression);
    setCurrentSheetSelectFields(deletFields);

    if (type === 'deleteField') {
      const updateFields = displayData.map(el => ({
        ...el,
        child: el.category === 'custom' ? el.child.filter(child => child.expression !== field.expression) : el.child
      }));
      setAllDisplayFields(updateFields);
    }
  }

  //排序欄位
  const handleUpdateSortFields = (sortFields) => {
    if (!sortFields || sortFields.length === 0) return;
    setCurrentSheetName('');

    const updateGeneralField = updateFields(selectedGeneralFields, sortFields);
    const updateConversionsFields = updateFields(selectedConversionsFields, sortFields);
    const updateCustomFields = updateFields(selectedCustomFields, sortFields);

    setSelectedGeneralFields(updateGeneralField);
    setSelectedConversionsFields(updateConversionsFields);
    setSelectedCustomFields(updateCustomFields);
  }

  const updateFields = (origiFields, sortFields) => {
    return origiFields.map((field) => {
      const matchField = _.find(sortFields, { expression: field.expression });
      if (matchField) {
        return { ...field, indexNumber: matchField.indexNumber };
      } else {
        return { ...field, indexNumber: null };
      }
    })
  }

  return (
    <Box mb={5}>
      <Typography
        sx={{
          ...theme.typography.h4_normal,
          mb: 2,
          color: theme.palette.grey.w700,
        }}
      >
        <PagesOutlinedIcon
          sx={{
            mr: 0.5,
            verticalAlign: 'sub'
          }}
        />
        <FormattedMessage id="createData.header.googleTab" />
      </Typography>

      <Box mb={0}>
        <CustomFormLabel><FormattedMessage id="createData.tab.googleTitle" /><span>*</span>
          <Tooltip title={<FormattedMessage id="createData.tab.tip" />} placement="bottom-start">
            <HelpOutlineIcon
              variant="dark"
              sx={{
                top: '2px',
                width: '16px',
                height: '16px',
                marginLeft: '4px'
              }}
            />
          </Tooltip>
        </CustomFormLabel>

        <BoxBorderGrey
          sx={{
            flexGrow: 1,
            display: 'flex',
            padding: 0,
            mb: 0
          }}
        >
          <GoogleFieldsAllTabs
            {...props}
            fieldsBlockHeight={fieldsBlockHeight}
            setSearchKeyword={setSearchKeyword}
          />

          <Box sx={{ flex: 3.2 }}>
            <Box
              sx={{
                background: `${theme.palette.grey.w100}`,
                borderBottom: `1px solid ${theme.palette.grey.w200}`,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Box
                  sx={{
                    padding: currentSheetName !== "" ? '16px 0px 12px 16px' : "26px",
                  }}
                >
                  {currentSheetName !== "" ?
                    <Typography>
                      <FormattedMessage id={currentSheetName} />
                    </Typography>
                    : ""}
                </Box>

                {/* 匯入自訂欄 */}
                <Box>
                  {selectedAdAccounts.length > 0 &&
                    <Typography
                      sx={{
                        cursor: 'pointer',
                        pr: '14px',
                        color: selectedCustomFields.length ? theme.palette.grey.w400 : mediaMainColor
                      }}
                      onClick={() => handleGetCustomFields()}
                    >
                      <FormattedMessage id="createData.button.importCustomFields" />
                    </Typography>
                  }
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                flex: 3.2,
                display: 'flex',
                padding: 0,
                mb: 0
              }}
            >
              <GoogleFieldsAllMetric
                {...props}
                filterOptionFields={filterOptionFields}
                searchKeyword={searchKeyword}
                setSearchKeyword={setSearchKeyword}
                mediaMainColor={mediaMainColor}
                fieldsBlockHeightS={fieldsBlockHeightS}
                changeDefinedFields={changeDefinedFields}
                handleDeleteFields={handleDeleteFields}
              />

              <GoogleFieldsSelected
                {...props}
                allfields={_.concat(selectedGeneralFields, selectedConversionsFields, selectedCustomFields)}
                fieldsBlockHeightS={fieldsBlockHeightS}
                mediaMainColor={mediaMainColor}
                handleUpdateSortFields={handleUpdateSortFields}
                handleDeleteFields={handleDeleteFields}
              />
            </Box>
          </Box>

        </BoxBorderGrey>
        <FormHelperText error sx={{ fontSize: 14 }}>
          {inputErrorMsg?.optionFieldName &&
            <FormattedMessage id={inputErrorMsg.optionFieldName} />
          }
        </FormHelperText>
        <FormHelperText error sx={{ fontSize: 14 }}>
          {inputErrorMsg?.excelSheet &&
            <FormattedMessage id={inputErrorMsg.excelSheet} />
          }
        </FormHelperText>

      </Box>
    </Box>
  )
}

export default GoogleFieldsData;